const XSS_PATTERNS = {
  SCRIPTS: /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
  SCRIPT_ATTRS: /on\w+\s*=\s*(?:".*?"|'.*?'|[^"'>\s]*)/gi,
  IFRAME: /<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi,
  OBJECT: /<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi,
  EMBED: /<embed\b[^<]*(?:(?!<\/embed>)<[^<]*)*<\/embed>/gi,
  JAVASCRIPT_URL: /javascript:/gi,
  EVAL_FUNC: /eval\((.*?)\)/gi,
  EXPRESSION: /expression\((.*?)\)/gi,
  VBSCRIPT: /vbscript:/gi,
  ALERT: /alert\((.*?)\)/gi,
};

const URL_REGEX = /^(https?:\/\/[^\s<>"']+)$/i;

function insertAtCursor(input, text) {
  const { selectionStart, selectionEnd, value } = input;
  return value.slice(0, selectionStart) + text + value.slice(selectionEnd);
}

function sanitizeTextContent(text) {
  let sanitized = text;

  Object.values(XSS_PATTERNS).forEach((pattern) => {
    sanitized = sanitized.replace(pattern, "");
  });

  return sanitized
    .replace(/\\/g, "&#x5C;") // заменяем бэкслеш
    .replace(/&/g, "&amp;"); // заменяем аперсанд
}

function sanitizeInput(value, isLinkField = false) {
  if (typeof value !== "string") return value;

  if (isLinkField || URL_REGEX.test(value.trim())) {
    return value.replace(/\\/g, "&#x5C;");
  }

  const urlPattern = /(https?:\/\/[^\s<>"']+)/gi;
  const parts = value.split(urlPattern);

  return parts
    .map((part, i) => (i % 2 === 1 ? part : sanitizeTextContent(part)))
    .join("");
}

function protectInput(input) {
  if (!input || !input.addEventListener) return;

  const isLinkField = input.classList.contains("link_data");

  input.addEventListener("beforeinput", (e) => {
    const unsafeTypes = ["insertText", "insertFromPaste"];
    if (!unsafeTypes.includes(e.inputType)) return;

    const data = e.data || "";
    const isURL = URL_REGEX.test(data.trim());
    if (isLinkField || isURL) return;

    const simulatedValue = insertAtCursor(input, data);
    const sanitized = sanitizeInput(simulatedValue, isLinkField);

    if (sanitized !== simulatedValue) {
      e.preventDefault();
      const cleaned = sanitizeInput(data, isLinkField);
      document.execCommand("insertText", false, cleaned);
    }
  });

  input.addEventListener("paste", (e) => {
    e.preventDefault();
    const text = (e.clipboardData || window.clipboardData).getData("text");
    const isURL = URL_REGEX.test(text.trim());
    const sanitized =
      isLinkField || isURL ? text : sanitizeInput(text, isLinkField);
    document.execCommand("insertText", false, sanitized);
  });
}

function protectAllInputs(container = document) {
  container
    .querySelectorAll(
      'input[type="text"], input[type="search"], input[type="url"], input[type="tel"], input[type="email"], input[type="password"], textarea:not(.js-wysiwyg):not(.js-wysiwyg-free):not(.js-wysiwyg-notification):not(.js-work-content-wysiwyg)'
    )
    .forEach(protectInput);
}

export { sanitizeInput, protectInput, protectAllInputs };
